import { Snackbar as MuiSnackBar, Alert } from '@mui/material';
import { ISnackBar, SnackBarVariant } from './ISnackBar';
import * as S from './SnackBar.styled';

const SnackBar = (props: ISnackBar): JSX.Element => {
  const {
    open,
    anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
    message,
    variant = SnackBarVariant.Success,
    autoHideDuration = 3000,
    onClose,
  } = props;

  const handleClose = () => {
    onClose?.();
  };

  return (
    <S.SnackBarWrapper>
      <MuiSnackBar
        anchorOrigin={anchorOrigin}
        open={open}
        onClose={handleClose}
        key={anchorOrigin.vertical + anchorOrigin.horizontal}
        autoHideDuration={autoHideDuration}
        sx={{ zIndex: 99999 }}>
        <Alert onClose={handleClose} severity={variant} variant='filled' sx={{ width: '100%' }}>
          {message}
        </Alert>
      </MuiSnackBar>
    </S.SnackBarWrapper>
  );
};

export default SnackBar;
